<template>
  <div id="plan_detail">
    <div class="page-header section-image" data-parallax="true" style="background-image: url('/static/img/activities.jpg'); height:50vh" >
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <div class="brand text-center">
              <h2 class="title" id="hide_edit" @click="edit_visit_detail(id, planType, planTime, planName)">{{ planName }}</h2>
              <h2 class="title">{{ planTime }}</h2>
              <h5 class="title description">
                {{ description }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main main-raised">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/visit"><b>活動花絮</b></router-link>
        </li>
        <li class="breadcrumb-item"><b>{{ planType }}</b></li>
        <li class="breadcrumb-item" aria-current="page"><b>{{ planName }}</b></li>
      </ol>
      <div class="container">
          <div class="row">
            <template v-for="(item, index) in imgData">
              <div class="col-12 col-md-3" :key="index">
                <div class="card">
                  <img class="card-img-bottom" :src="item.img" alt="Card image cap">
                </div>
              </div>
            </template>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "plan_detail",
  props: ["id","planType", "planTime", "planName"],
  data() {
    return {
      description:'',
      imgData:[]
    };
  },
  methods: {
    getData: function(){
      var vm = this;
      var data = []; 
      var newItem = []
      
      axios
        .post(`/api/getvisitDetailEach`,{
          pid: vm.id
        })
        .then(res => {
          vm.imgData = res.data.data;  
        })
        .catch(err => {
          console.log(err);
        });   
    },
    edit_visit_detail: function(id, planType, planTime, planName){      
      // console.log(id +'/'+ planType +'/'+ planTime +'/'+ planName);
      var vm = this;
        document.querySelector('#hide_edit').addEventListener('click', function (evt) {
            if(evt.detail === 3){
                vm.$router.push({ name: 'edit_visit_detail', params: { id: id, planType: planType, planTime: planTime, planName: planName } }).catch(error => {
                    if (error.name != "NavigationDuplicated") {
                        throw error;
                    }
                });
            }
        });
    }
  },
  filters: {},
  computed: {},
  created() {
    this.getData();   
  },
  mounted() {
    
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/visit/visit_detail.vue